import { inject } from '@angular/core';
import { NimmstaDataSource } from '@nimmsta/ng-commons-lib/data-table';
import { Pageable } from '@nimmsta/ng-commons-lib/models';
import { SFSOptions } from '@nimmsta/ng-commons-lib/data-access';
import { finalize, lastValueFrom, Observable, switchMap, tap } from 'rxjs';
import { SimpleScanner } from '../models/scanner';
import { ScannerService } from './scanner.service';
import { WorkerNameService } from '../device/scanner/worker-name.service';

export class ScannerDatasource extends NimmstaDataSource<SimpleScanner> {
  private workerNameService = inject(WorkerNameService);

  private scannerService: ScannerService;

  constructor() {
    const scannerService = inject(ScannerService);
    super(scannerService as never);
    this.scannerService = scannerService;
  }

  override loadData(options?: Partial<SFSOptions>): Observable<Pageable<SimpleScanner>> {
    this.loadingSubject.next(true);
    return this.scannerService.listItems({
      ...options,
      filter: options?.filter?.concat(this.defaultFilter) || this.defaultFilter,
    }).pipe(
      finalize(() => {
        this.loadingSubject.next(false);
      }),
      tap((page) => {
        this.dataSubject.next(page.content);
        this.count = page.totalElements;
        this.data = page;
      }),
      switchMap(async (page) => {
      const orgIds = page.content.map((c) => c.lastConnectedHandheldId).filter((c) => !!c) as string[];
      if (orgIds.length > 0) {
        await lastValueFrom(this.workerNameService.getNameMap(orgIds));
      }
      await lastValueFrom(this.scannerService.resolveSoftwareStatuses(page.content));
      return page;
      }),
    );
  }
}
